import React, { useEffect, useState } from "react";
import "./SectorialIndices.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";
import FOTopGainerLooser from "../fo-top-gainer-looser/FOTopGainerLooser";

export default function SectorialIndices() {

    // WebSocket connection
    const { sectorialIndicesData, strategyIndicesData, stockSectorAnalysisData } = useStockApiWebsocket(
        environment.stockApiDayRangeDataWSUrl
    );

    const [sectorData, setSectorData] = useState([]);
    const [strategyData, setStrategyData] = useState([]);
    const [stockSectorAnalysis, setStockSectorAnalysis] = useState([]);
    const [activeTab, setActiveTab] = useState("SECTORIAL_INDICES");

    /* ============================================== */

    useEffect(() => {
        if (Array.isArray(sectorialIndicesData) && sectorialIndicesData.length > 0) {
            setSectorData(sectorialIndicesData);
            // console.log("Sector Data:", sectorialIndicesData);
        }
        // Strategy data
        if (Array.isArray(strategyIndicesData) && strategyIndicesData.length > 0) {
            setStrategyData(strategyIndicesData);
            console.log("Strategy Data:", strategyData);
        }
    }, [sectorialIndicesData, strategyIndicesData]);

    useEffect(() => {
        if (Array.isArray(stockSectorAnalysisData) && stockSectorAnalysisData.length > 0) {
            setStockSectorAnalysis(stockSectorAnalysisData);
            //  getTopAndBottomCHP(stockSectorAnalysisData);
            console.log("Stock Sector Analysis Data:", stockSectorAnalysisData);
        }
    }, [stockSectorAnalysisData]);

    const getTopAndBottomCHP = (data) => {
        if (!Array.isArray(data) || data.length < 2) return {};

        // Sort by CHP ascending
        const sorted = [...data].sort((a, b) => a.chp - b.chp);

        return {
            firstLowest: sorted[0],
            secondLowest: sorted[1],
            thirdLowest: sorted[2],

            firstHighest: sorted[sorted.length - 1],
            secondHighest: sorted[sorted.length - 2],
            thirdHighest: sorted[sorted.length - 3],
        };
    };
    // Header Data
    const headerSource = strategyData?.[0] ?? {};
    const headerData = [
        {
            label1: "1st HS",
            value1: getTopAndBottomCHP(stockSectorAnalysis)?.firstHighest?.symbol?.split(":")[1]?.split("-")[0] ?? "--",
            label2: "CHP",
            value2: getTopAndBottomCHP(stockSectorAnalysis)?.firstHighest?.chp ?? "--",
        },
        {
            label1: "2nd HS",
            value1: getTopAndBottomCHP(stockSectorAnalysis)?.secondHighest?.symbol?.split(":")[1]?.split("-")[0] ?? "--",
            label2: "CHP",
            value2: getTopAndBottomCHP(stockSectorAnalysis)?.secondHighest?.chp ?? "--",
        },
        {
            label1: "1st LS",
            value1: getTopAndBottomCHP(stockSectorAnalysis)?.firstLowest?.symbol?.split(":")[1]?.split("-")[0] ?? "--",
            label2: "CHP",
            value2: getTopAndBottomCHP(stockSectorAnalysis)?.firstLowest?.chp ?? "--",
        },
        {
            label1: "2nd LS",
            value1: getTopAndBottomCHP(stockSectorAnalysis)?.secondLowest?.symbol?.split(":")[1]?.split("-")[0] ?? "--",
            label2: "CHP",
            value2: getTopAndBottomCHP(stockSectorAnalysis)?.secondLowest?.chp ?? "--",
        },
        {
            label1: "Date",
            value1: headerSource?.localDate ?? "--",
            label2: "Time",
            value2: headerSource?.localTime ?? "--",
        },
    ];

    // Helper for color intensity
    const getCardStyle = (pChange) => {
        if (pChange > 2) return { backgroundColor: "#0f7a3f" };
        if (pChange > 1) return { backgroundColor: "#1f9d55" };
        if (pChange > 0) return { backgroundColor: "#7bc47f" };
        if (pChange < -2) return { backgroundColor: "#b71c1c" };
        if (pChange < -1) return { backgroundColor: "#e57373" };
        if (pChange < 0) return { backgroundColor: "#f28b82" };
        return { backgroundColor: "#9e9e9e" };
    };

    const getChpColor = (value) => {
        const num = Number(value);
        if (isNaN(num)) return "white";
        if (num > 0) return "#0dc80d";   // green
        if (num < 0) return "rgb(228, 67, 136)";   // red
        return "white";
    };
    const leftData = headerData.filter(item => item.label1 !== "Date");
    const rightData = headerData.find(item => item.label1 === "Date");
    return (
        <div className="sectorial-indicies">

            {/* ================= HEADER ================= */}
            <header className="header">
                <nav className="nav-container">
                    <div className="header-flex">

                        {/* ===== LEFT SIDE ===== */}
                        <div className="left-nav">

                            <div className="logo-container">
                                <img
                                    src="/assets/images/noptionwave-logo-1.png"
                                    className="header-logo"
                                    alt="logo"
                                />
                            </div>

                            {leftData.map((item, idx) => {
                                const color =
                                    item.label2 === "CHP"
                                        ? getChpColor(item.value2)
                                        : "white";

                                return (
                                    <div className="header-item" key={idx}>
                                        <span className="header-line" style={{ color }}>
                                            {item.label1} : {item.value1}
                                        </span>

                                        <span className="header-line" style={{ color }}>
                                            {item.label2} : {item.value2}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>

                        {/* ===== RIGHT SIDE (DATE & TIME) ===== */}
                        {rightData && (
                            <div className="right-nav">
                                <span className="header-line" style={{ color: "white" }}>
                                    {rightData.label1} : {rightData.value1}
                                </span>
                                <span className="header-line" style={{ color: "white" }}>
                                    {rightData.label2} : {rightData.value2}
                                </span>
                            </div>
                        )}

                    </div>
                </nav>
            </header>

            {/* ===== TABS ===== */}
            <div className="tab-container">
                <div className="tab">

                    <button className={`tablinks sub-header-font ${activeTab === "SECTORIAL_INDICES" ? "active" : ""}`}
                        onClick={() => setActiveTab("SECTORIAL_INDICES")}  >
                        SECTORIAL INDICES
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "STRATEGY_INDICES" ? "active" : ""}`}
                        onClick={() => setActiveTab("STRATEGY_INDICES")} >
                        STRATEGY INDICES
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "FO_TOP_GAINERS_LOSERS" ? "active" : ""}`}
                        onClick={() => setActiveTab("FO_TOP_GAINERS_LOSERS")} >
                        F&O TOP GAINERS & LOSERS
                    </button>

                </div>
            </div>

            {/* ================= GRID ================= */}

            {/* ===== SECTORIAL INDICES ===== */}
            {activeTab === "SECTORIAL_INDICES" && (
                <div className="table-container">

                    <div className="sector-header">
                        <h2 className="sector-heading">
                            <span className="sectorial-indices-span">SECTORIAL INDICIES</span>
                        </h2>
                    </div>

                    <div className="greed-outer-container">
                        <div className="sector-grid sector-grid-sectorial">
                            {sectorData.map((item, index) => {

                                const isPositive = item.pChange >= 0;

                                return (
                                    <div key={index} className="sector-card" style={getCardStyle(item.pChange)}>

                                        <div className="sector-title">{item.index}</div>

                                        <div className="sector-values">
                                            <span className="price">
                                                {Number(item.current).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </span>

                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                {isPositive ? "+" : ""}
                                                {item.pChange}%
                                            </span>
                                        </div>

                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* ===== ALL SECTORIAL ===== */}
                    <div className="sector-header">
                        <h2 className="sector-heading">
                            <span className="sectorial-indices-span">ALL SECTORIAL INDICIES</span>
                        </h2>
                    </div>

                    <div className="sectorial-indices-grid">
                        {sectorData.map((item, index) => {

                            const isPositive = item.pChange >= 0;

                            return (
                                <div key={index} className="sectorial-indices-card">

                                    {/* HEADER */}
                                    <div
                                        className="sectorial-indices-stock-header"
                                        style={getCardStyle(item.pChange)}
                                    >
                                        <div className="sectorial-indices-stock-title">
                                            <span>{item.index}</span>

                                            <span className="price">
                                                {Number(item.current).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </span>

                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                {isPositive ? "+" : ""}
                                                {item.pChange}%
                                            </span>
                                        </div>
                                    </div>

                                    {/* BODY */}
                                    <div className="greed-outer-container">
                                        <div className="sector-grid">
                                            {(item.sectorialIndicesStockModelList || []).map((stock, index) => {

                                                const isPositive = stock.pChange >= 0;

                                                return (
                                                    <div key={index} className="sector-card" style={getCardStyle(stock.pChange)}>

                                                        <div className="sector-title">{stock.symbol}</div>

                                                        <div className="sector-values">
                                                            <span className="price">
                                                                {Number(stock.lastPrice).toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}
                                                            </span>

                                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                                {isPositive ? "+" : ""}
                                                                {stock.pChange}%
                                                            </span>
                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                </div>
                            );
                        })}
                    </div>

                </div>
            )}

            {/* ===== STRATEGY INDICES ===== */}
            {activeTab === "STRATEGY_INDICES" && (
                <div className="table-container">

                    {/* <div className="sector-header">
                        <h2 className="sector-heading">
                            <span className="sectorial-indices-span">STRATEGY INDICIES</span>
                        </h2>
                    </div> */}

                    {/* <div className="greed-outer-container">
                        <div className="sector-grid sector-grid-sectorial">
                            {strategyData.map((item, index) => {

                                const isPositive = item.pChange >= 0;

                                return (
                                    <div key={index} className="sector-card" style={getCardStyle(item.pChange)}>

                                        <div className="sector-title">{item.index}</div>

                                        <div className="sector-values">
                                            <span className="price">
                                                {Number(item.current).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </span>

                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                {isPositive ? "+" : ""}
                                                {item.pChange}%
                                            </span>
                                        </div>

                                    </div>
                                );
                            })}
                        </div>
                    </div> */}
                    {/* ===== ALL SECTORIAL ===== */}
                    {/* <div className="sector-header">
                        <h2 className="sector-heading">
                            <span className="sectorial-indices-span">ALL STRATEGY INDICIES</span>
                        </h2>
                    </div> */}

                    <div className="sectorial-indices-grid">
                        {strategyData.map((item, index) => {

                            const isPositive = item.pChange >= 0;

                            return (
                                <div key={index} className="sectorial-indices-card">

                                    {/* HEADER */}
                                    <div
                                        className="sectorial-indices-stock-header"
                                        style={getCardStyle(item.pChange)}
                                    >
                                        <div className="sectorial-indices-stock-title">
                                            {/* <span>{item.index}</span> */}
                                            <span className="momentum-stock">
                                                {index === 0 ? "MOMENTUM STOCK" : index === 1 ? "HIGH MOMENTUM STOCK" : `STRATEGY ${index + 1}`}
                                            </span>
                                            {/* <span className="price">
                                                {Number(item.current).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </span>

                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                {isPositive ? "+" : ""}
                                                {item.pChange}%
                                            </span> */}
                                        </div>
                                    </div>

                                    {/* BODY */}
                                    <div className="greed-outer-container">
                                        <div className="sector-grid">
                                            {(item.strategyIndicesStockModelList || []).map((stock, index) => {

                                                const isPositive = stock.pChange >= 0;

                                                return (
                                                    <div key={index} className="sector-card" style={getCardStyle(stock.pChange)}>

                                                        <div className="sector-title">{stock.symbol}</div>

                                                        <div className="sector-values">
                                                            <span className="price">
                                                                {Number(stock.lastPrice).toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}
                                                            </span>

                                                            <span className={`percent ${isPositive ? "pos" : "neg"}`}>
                                                                {isPositive ? "+" : ""}
                                                                {stock.pChange}%
                                                            </span>
                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {activeTab === "FO_TOP_GAINERS_LOSERS" && (
                <div className="table-container">
                    <FOTopGainerLooser />
                </div>
            )}
        </div>
    );
}